/**
 * Local-date helpers (avoid UTC shifts from toISOString()).
 */

export function formatLocalDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseLocalDate(dateStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function getTodayParts(referenceDate = new Date()) {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth() + 1;
  const day = referenceDate.getDate();
  const daysInMonth = new Date(year, month, 0).getDate();
  return { year, month, day, daysInMonth };
}

export function getCurrentMonthStart(referenceDate = new Date()) {
  const { year, month } = getTodayParts(referenceDate);
  return `${year}-${String(month).padStart(2, "0")}-01`;
}

export function getTodayLocalDate(referenceDate = new Date()) {
  return formatLocalDate(referenceDate);
}

export function calendarDaysInclusive(startDate, endDate) {
  if (!startDate || !endDate) return 0;
  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);
  return Math.floor((end - start) / 86400000) + 1;
}

export function dateRangeIncludesCurrentMonth(startDate, endDate, referenceDate = new Date()) {
  const { year, month } = getTodayParts(referenceDate);
  const monthStart = `${year}-${String(month).padStart(2, "0")}-01`;
  const monthEnd = formatLocalDate(new Date(year, month, 0));
  const filterStart = startDate || "1900-01-01";
  const filterEnd = endDate || "2099-12-31";
  return filterStart <= monthEnd && filterEnd >= monthStart;
}

/**
 * True when the range is "this month so far" (month start through today).
 */
export function isCurrentMonthToDateView(startDate, endDate, referenceDate = new Date()) {
  const monthStart = getCurrentMonthStart(referenceDate);
  const today = getTodayLocalDate(referenceDate);
  return startDate === monthStart && endDate === today;
}

/**
 * Prorate monthly budget amounts to match the selected date range.
 */
export function getBudgetProrationFactor(startDate, endDate) {
  if (!startDate || !endDate) {
    return 1;
  }

  const periodDays = calendarDaysInclusive(startDate, endDate);
  if (periodDays <= 0) return 1;

  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);

  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth()
  ) {
    const daysInMonth = new Date(
      start.getFullYear(),
      start.getMonth() + 1,
      0,
    ).getDate();
    return periodDays / daysInMonth;
  }

  return periodDays / 30;
}
